import React from "react";
import { RotatingLines } from "react-loader-spinner";
import "../styles/Loader.css";

const Loader = () => {
  return (
    <div className="loader">
      <RotatingLines strokeColor="grey" strokeWidth="5" animationDuration="1.6" width="96" visible={true} />
    </div>
  );
};

export default Loader;
